class QuickAddModal extends HTMLElement {
  constructor() {
    super(), this.isOpen=!1, this.modalContent=this.querySelector('[id^="QuickAddInfo-"]'), this.onKeyUp=this.onKeyUp.bind(this), this.onClickInside=this.onClickInside.bind(this), this.onCloseClick=this.onCloseClick.bind(this), this.onMouseMove=this.onMouseMove.bind(this), this.animateFollow=this.animateFollow.bind(this), this.onMediaChange=this.onMediaChange.bind(this), this.mouseX=0, this.mouseY=0, this.floatingX=0, this.floatingY=0, this.raf=null, this.mediaQuery=window.matchMedia("(pointer: fine) and (min-width: 990px)"), this.dynamicEnabled=!1, document.body.appendChild(this), window.addEventListener("resize", ()=> {
      this.modalContent.querySelectorAll(".js-media-list").forEach(element=> {
        element.swiper?.destroy()
      }), setTimeout(()=> {
        sliderInit(this.modalContent, !0)
      }, 200)
    })
  }
  async show(opener, event) {
    this.isOpen = true;
    opener.setAttribute("aria-disabled", "true");
    opener.classList.add("loading");

    const spinner = opener.querySelector(".loading-overlay__spinner");
    if (spinner) spinner.classList.remove("hidden");

    try {
      const rawProductUrl = opener.getAttribute("data-product-url");
      if (!rawProductUrl) throw new Error("Quick View product URL is missing");

      const productUrl = new URL(rawProductUrl, window.location.origin);
      const requestUrls = [productUrl.href];
      let productElement = null;

      for (const requestUrl of requestUrls) {
        const response = await fetch(requestUrl, {
          credentials: "same-origin",
          headers: {
            "X-Requested-With": "XMLHttpRequest",
          },
        });

        if (!response.ok) continue;

        const responseText = await response.text();
        const responseHTML = new DOMParser().parseFromString(
          responseText,
          "text/html"
        );

        productElement = responseHTML.querySelector(
          'section[id^="MainProduct-"], [data-section-type="main-product"], .premium-product-builder'
        );

        if (productElement) break;
      }

      if (!productElement) {
        throw new Error(
          "Quick View could not find usable product markup."
        );
      }

      this.productElement = productElement;
      this.dialogEl = this.querySelector('[role="dialog"]');
      this.closeButton = this.querySelector('[id^="ModalClose-"]');

      const isPremiumProduct =
        productElement.matches(".premium-product-builder") ||
        Boolean(productElement.querySelector(".premium-product-builder"));

      this.classList.toggle("is-premium-source", isPremiumProduct);
      const modalPanel = this.querySelector(".quick-add-modal__content");
      if (modalPanel) {
        if (isPremiumProduct) {
          modalPanel.style.setProperty(
            "height",
            "min(61rem, calc(100dvh - 3rem))",
            "important"
          );
        } else {
          modalPanel.style.removeProperty("height");
        }
      }

      this.closeButton?.addEventListener("click", this.onCloseClick);
      this.addEventListener("keyup", this.onKeyUp);
      this.addEventListener("click", this.onClickInside);

      this.preventDuplicatedIDs();
      this.removeDOMElements();
      this.setInnerHTML(this.modalContent, this.productElement, opener);
      if (isPremiumProduct) {
        this.buildPremiumQuickview();
        this.classList.remove("is-qv-preparing");
      }

      try {
        if (window.Shopify && Shopify.PaymentButton) {
          Shopify.PaymentButton.init();
        }
      } catch (paymentButtonError) {
        console.warn(
          "[Herbz Quick View] Shopify Payment Button could not initialize",
          paymentButtonError
        );
      }

      if (window.ProductModel) window.ProductModel.loadShopifyXR();

      this.updateImageSizes();
      this.preventVariantURLSwitching();

      setTimeout(() => {
        this.classList.add("active");
      });

      this.openedBy = opener;
      this.setAttribute("open", "");
      this.dataset.qvProductUrl = rawProductUrl;
      document.body.classList.add("overflow-hidden");
      trapFocus(this, this.dialogEl);
      window.pauseAllMedia?.();

      this.mediaQuery.addEventListener("change", this.onMediaChange);
      this.onMediaChange(this.mediaQuery);

      if (event && this.dynamicEnabled) {
        this.instantPositionCloseButton(event);
      }

      this.addEventListener(
        "transitionend",
        () => {
          trapFocus(this, this.querySelector(".quick-add-modal__content"));
        },
        { once: true }
      );

      document.dispatchEvent(
        new CustomEvent("quickview:loaded", {
          detail: {
            modal: this,
            productUrl: rawProductUrl,
          },
        })
      );
    } catch (error) {
      console.error("[Herbz Quick View]", error);
      this.setAttribute("data-quickview-error", "true");
    } finally {
      opener.removeAttribute("aria-disabled");
      opener.classList.remove("loading");

      const loadingSpinner = opener.querySelector(
        ".loading-overlay__spinner"
      );
      if (loadingSpinner) loadingSpinner.classList.add("hidden");

      this.modalContent
        .querySelectorAll(".js-media-list")
        .forEach((element) => {
          element.swiper?.destroy();
        });

      sliderInit(this.modalContent, true);
      this.initProductAccordion();
      this.setScrollClass(this.modalContent);
    }
  }
  hide(preventFocus=!1) {
    this.isOpen=!1, this.classList.add("closing"), setTimeout(()=> {
      this.modalContent.innerHTML="", this.modalContent.querySelectorAll(".js-media-list").forEach(function() {
        this.swiper?.destroy()
      }), sliderInit(this.modalContent, !0), preventFocus&&(this.openedBy=null), this.classList.remove("active"), this.removeAttribute("open"), removeTrapFocus(this.openedBy), window.pauseAllMedia?.(), document.body.classList.remove("overflow-hidden"), document.body.dispatchEvent(new CustomEvent("modalClosed")), this._disableDynamic(), this.mediaQuery.removeEventListener("change", this.onMediaChange);
      const mediaContent=document.querySelector(".product-media-modal__content");
      mediaContent&&mediaContent.classList.remove("zoom"), this.classList.remove("closing")
    }, 250), this.addEventListener("transitionend", ()=> {
      this.openedBy?.closest(".card__links").nextElementSibling.focus( {
        preventScroll:!0
      })
    },  {
      once:!0
    })
  }
  setInnerHTML(element, html, opener) {
    const mediaSublist=html.querySelector(".product-media-sublist-outer");
    mediaSublist&&mediaSublist.remove(), element.innerHTML=html.innerHTML, element.querySelectorAll("script").forEach(oldScriptTag=> {
      const newScriptTag=document.createElement("script");
      Array.from(oldScriptTag.attributes).forEach(attribute=> {
        newScriptTag.setAttribute(attribute.name, attribute.value)
      }), newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML)), oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag)
    });
    const moreBtn=document.createElement("a");
    moreBtn.innerHTML=`<span>${theme.quickviewMore}</span>`, moreBtn.setAttribute("href", opener.getAttribute("data-product-url")), moreBtn.setAttribute("class", "product-full-details button button--underline");
    const infoContainer=element.querySelector(".product-info-container");
    infoContainer&&infoContainer.appendChild(moreBtn)
  }
  buildPremiumQuickview() {
    const builder=this.modalContent.querySelector(".premium-product-builder");
    const scope=builder||this.modalContent;
    const inner=scope.querySelector(".premium-product-builder__inner"),gallery=scope.querySelector(".premium-product-builder__gallery"),media=scope.querySelector(".premium-product-builder__media-main"),summary=scope.querySelector(".premium-product-builder__summary"),title=scope.querySelector(".premium-product-builder__title"),thca=scope.querySelector(".premium-product-builder__thca-strength"),productForm=scope.querySelector(".premium-product-builder__product-form");
    if(!inner||!gallery||!media||!summary||!title||!productForm)return!1;
    const header=document.createElement("div");
    header.className="quickview-essential__header";
    header.appendChild(title);
    thca&&header.appendChild(thca);
    gallery.replaceChildren(media);
    summary.replaceChildren(header,productForm);
    inner.replaceChildren(gallery,summary);
    builder?.classList.add("premium-product-builder--quickview-essential");
    this.classList.add("is-qv-essential-built");
    return!0
  }
  toggleScrollClass(element) {
    const productOuter=element?.querySelector(".product-outer");
    if(!productOuter)return;
    const visibleHeight=this.querySelector(".quick-add-modal__content").getBoundingClientRect().height-48;
    productOuter.scrollHeight>visibleHeight?element.classList.add("has-scroll"):element.classList.remove("has-scroll")
  }
  calcHeight() {
    const productMedia=this.querySelector(".product-media");
    if(!productMedia)return;
    const mediaAspectRatio=productMedia.getAttribute("data-image-type");
    mediaAspectRatio==="landscape"&&this.style.setProperty("--image-height", "var(--image-height--landscape)"), mediaAspectRatio==="portrait"&&this.style.setProperty("--image-height", "var(--image-height--portrait)"), mediaAspectRatio==="square"&&this.style.setProperty("--image-height", "var(--image-height--square)")
  }
  setScrollClass(element) {
    const resizeObserver=new ResizeObserver(entries=> {
      const[entry]=entries, dialog=entry.target.querySelector(".quick-add-modal__content-info");
      dialog&&this.isOpen&&(this.calcHeight(), this.toggleScrollClass(dialog))
    });
    element&&resizeObserver.observe(this)
  }
  initProductAccordion() {
    this.querySelectorAll(".product-dropdown__toggle").forEach(toggle=> {
      toggle.addEventListener("click", event=> {
        event.preventDefault();
        const description=toggle.nextElementSibling?.classList.contains("product-dropdown__content")?toggle.nextElementSibling:toggle.previousElementSibling?.classList.contains("product-dropdown__content")?toggle.previousElementSibling:null;
        description&&(toggle.classList.contains("active")?slideUp(toggle, description, 300):slideDown(toggle, description, 300))
      })
    })
  }
  removeDOMElements() {
    [
      ".pickup-availability",
      ".share-buttons",
      ".product-popup",
      ".complementary-products",
      "product-modal",
      ".product-description-wrapper",
      ".product-description",
      ".product__description",
      "[data-product-description]",
      ".premium-product-builder__accordions",
      ".premium-product-builder__thumbs",
      ".premium-product-builder__gallery-features",
      ".premium-product-builder__gallery-purchase",
      ".premium-product-builder__mobile-purchase-slot",
      ".premium-product-builder__reviews",
      ".premium-product-builder__reviews-custom",
      ".premium-product-builder__eyebrow",
      ".premium-product-builder__accent-heading",
      ".premium-product-builder__variant-amount",
      ".premium-product-builder__subtitle",
      ".premium-product-builder__price-row",
      ".premium-product-builder__gram-price",
      ".premium-product-builder__highlights",
      ".premium-product-builder__stock",
      ".premium-product-builder__merch-shipping",
      ".premium-product-builder__benefits",
      ".premium-product-builder__delivery",
      ".premium-product-builder__delivery-options",
      ".premium-product-builder__checkout-trust",
      ".premium-product-builder__shipping-icons",
      ".premium-product-builder__guarantee",
      ".premium-product-builder__size-guide",
      ".premium-product-builder__info-link"
    ].forEach(selector=> {
      this.productElement.querySelectorAll(selector).forEach(el=>el.remove())
    })
  }
  preventDuplicatedIDs() {
    const sectionId=this.productElement.dataset.section||this.productElement.getAttribute("data-section-id")||this.productElement.id||"premium-product-builder";
    this.productElement.innerHTML=this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${sectionId}`), this.productElement.querySelectorAll("variant-radios").forEach(variantSelect=> {
      variantSelect.dataset.originalSection=sectionId
    })
  }
  preventVariantURLSwitching() {
    this.modalContent.querySelector("variant-radios")&&this.modalContent.querySelector("variant-radios").setAttribute("data-update-url", "false")
  }
  updateImageSizes() {
    const productMedia=this.modalContent.querySelector(".product-media");
    if(!productMedia)return;
    const productMediaList=productMedia.querySelector(".product-media__list.js-media-list")||productMedia.querySelector(".product-media__list");
    if(!productMediaList)return;
    const mediaImages=productMediaList.querySelectorAll(".product__media img");
    if(!mediaImages.length)return;
    const aspectRatio=productMedia.getAttribute("data-image-type")||"square";
    let mediaRatio=1;
    switch(aspectRatio) {
      case"landscape":mediaRatio=1.33;
      break;
      case"portrait":mediaRatio=.76;
      break;
      case"square":mediaRatio=1;
      break;
      default:mediaRatio=1;
      break
    }
    mediaImages.forEach(img=> {
      const imgAspectRatio=img.getAttribute("width")/img.getAttribute("height");
      let calcRatio=1;
      imgAspectRatio>mediaRatio&&(calcRatio=+(imgAspectRatio/mediaRatio).toFixed(2));
      const mediaImageSizes=`(min-width: 1360px) calc(${calcRatio} * 512px), (min-width: 1200px) calc(${calcRatio} * 456px), (min-width: 990px) calc(${calcRatio} * 414px), (min-width: 576px) calc(${calcRatio} * 95vw), calc(${calcRatio} * 100vw - 4rem)`;
      img.setAttribute("sizes", mediaImageSizes)
    })
  }
  onCloseClick(e) {
    if(e.stopPropagation(), !this.closeButton)return this.hide();
    this.closeButton.classList.add("pulse"), this.hide();
    const done=()=> {
      this.closeButton.removeEventListener("animationend", done), this.closeButton.classList.remove("pulse")
    };
    this.closeButton.addEventListener("animationend", done)
  }
  disconnectedCallback() {
    this.closeButton?.removeEventListener("click", this.onCloseClick), this.removeEventListener("keyup", this.onKeyUp), this.removeEventListener("click", this.onClickInside), this._disableDynamic(), this.mediaQuery.removeEventListener("change", this.onMediaChange)
  }
  instantPositionCloseButton(event) {
    if(!this.closeButton)return;
    const offsetX=32, offsetY=32;
    this.mouseX=event.clientX-offsetX, this.mouseY=event.clientY-offsetY, this.floatingX=this.mouseX, this.floatingY=this.mouseY, Object.assign(this.closeButton.style,  {
      position:"fixed", zIndex:"9999", left:`${this.floatingX}px`, top:`${this.floatingY}px`, pointerEvents:"none"
    });
    const content=this.querySelector(".quick-add-modal__content");
    if(content) {
      const rect=content.getBoundingClientRect();
      event.clientX>=rect.left&&event.clientX<=rect.right&&event.clientY>=rect.top&&event.clientY<=rect.bottom?this.classList.remove("cursor-active"):this.classList.add("cursor-active")
    }
  }
  onMediaChange(e) {
    e.matches&&!this.dynamicEnabled?(this.dynamicEnabled=!0, document.addEventListener("mousemove", this.onMouseMove), this.raf=requestAnimationFrame(this.animateFollow)):!e.matches&&this.dynamicEnabled&&this._disableDynamic()
  }
  _disableDynamic() {
    this.dynamicEnabled&&(document.removeEventListener("mousemove", this.onMouseMove), cancelAnimationFrame(this.raf), this.dynamicEnabled=!1, this.closeButton&&(this.closeButton.style.position="", this.closeButton.style.left="", this.closeButton.style.top="", this.closeButton.style.pointerEvents="", this.closeButton.style.zIndex="", this.classList.remove("cursor-active")))
  }
  onMouseMove(event) {
    if(!this.closeButton)return;
    const offsetX=32, offsetY=32;
    this.mouseX=event.clientX-offsetX, this.mouseY=event.clientY-offsetY, event.target.closest(".quick-add-modal__content")?this.classList.remove("cursor-active"):this.classList.add("cursor-active")
  }
  animateFollow() {
    if(!this.closeButton)return;
    const ease=.25;
    this.floatingX+=(this.mouseX-this.floatingX)*ease, this.floatingY+=(this.mouseY-this.floatingY)*ease, Object.assign(this.closeButton.style,  {
      position:"fixed", zIndex:"9999", left:`${this.floatingX}px`, top:`${this.floatingY}px`, pointerEvents:"none"
    }), this.raf=requestAnimationFrame(this.animateFollow)
  }
  onKeyUp(event) {
    event.code==="Escape"&&this.hide()
  }
  onClickInside(event) {
    event.target.closest(".quick-add-modal__content")||this.onCloseClick(event)
  }
  onCloseClick(e) {
    if(e.stopPropagation(), !this.closeButton)return this.hide();
    this.closeButton.classList.add("pulse"), this.hide();
    const done=()=> {
      this.closeButton.removeEventListener("animationend", done), this.closeButton.classList.remove("pulse")
    };
    this.closeButton.addEventListener("animationend", done)
  }
}
customElements.get("quick-add-modal")||customElements.define("quick-add-modal", QuickAddModal);
